import AbstractView from 'abstract';
import Vue from 'vue'
import store from 'definitions/store'

export class Main extends AbstractView {
    constructor(domElementId) {
        return super(domElementId);
    }

    init() {
        const CustomImage = () => import(/* webpackChunkName: "snippet-items-custom-image" */ 'components/SnippetTemplate/Items/CustomImage')
        new Vue({
            el: "#" + this.elemId,
            store,
            render: h => h(CustomImage, {props: eval(this.elemId)})
        })
    }
}
